<template>
  <!-- banner :style="{backgroundImage:'url('+pic+')'}" -->
  <div class="subbanner">
    <div class="container">
      <div class="curpage" v-if="(!detailInfo || showTitle) && firstNav" v-text="firstNav.name"></div>
      <crumbs :detailInfo="detailInfo" :custNav="custNav" />
      <!-- 搜索框 -->
      <slot name="searchBox"></slot>
    </div>
  </div>
</template>

<script>
import colums from '../colums/colums.js';
import crumbs from './common/crumbs.vue';
import sbannerPic from "@/assets/images/subbanner.jpg"
export default {
  name: 'sbanner',
  props: {
    pic: String,
    detailInfo: Object,
    custNav: Array,
    showTitle: Boolean
  },
  components: {
    crumbs
  },
  data() {
    return {
      sbannerPic,
      firstNav: {},
      nav: colums.navlist,
      colums: colums.jmkcate,
    }
  },
  mounted() {
    let path = this.$route.path.slice(1)
    let paths = path.split('/')
    let newNav = [];
    try {
      paths.forEach((item, index) => {
        let navs = {}
        if (index == 0) {
          this.nav.forEach(navItem => {
            if (navItem.eName == item) {
              navs = {
                name: navItem.name,
                path: navItem.path,
                eName: navItem.eName
              }
              this.firstNav = navs;
            }
          })
        }
      });
    } catch (err) { }

    //如果主栏目里面没有配置，则直接通过title取内容
    if (newNav.length == 0) {
      try {
        let title = this.$route.meta.title.split('-')[0];
        let obj = {
          name: title,
          path: this.$route.path,
          eName: this.$route.name
        }
        this.firstNav = obj;
      } catch (err) { }
    }
  },

}
</script>